import React from 'react';
import { Skeleton } from 'antd';

export default ({ ...rest }) => <Skeleton {...rest} />;
